module.exports = __webpack_public_path__ + "img/qrcode.69908b91.svg";